export default __webpack_public_path__ + "static/media/FinOverviewImg.35d5739b.png";